import React from "react";
import { Link } from "react-router-dom";

export default function Logo({ className = "", onClick }) {
  return (
    <Link to="/" onClick={onClick} data-testid="logo-link" className={`inline-flex items-baseline gap-[2px] ${className}`}>
      <span className="font-logo text-2xl md:text-[26px] tracking-[0.18em] lowercase text-ink">o</span>
      <span className="mx-[1px] inline-block h-[6px] w-[6px] translate-y-[-3px] rounded-full bg-terra" />
      <span className="font-logo text-2xl md:text-[26px] tracking-[0.18em] lowercase text-ink">crea</span>
    </Link>
  );
}
